<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            <a routerLink="/company" style="color: #003E53;">Company</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            Samples
        </li>
    </ol>
</nav>

<div class="row compact-content">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row  gx-3">
                <div class="col-md-6 col-12 mb-2 mb-md-0">
                    <h6 class="mb-0 text-dark fw-bold">All Samples from <span style="color:#003E53">{{
                            companyDetail?.name }}</span></h6>

                </div>
                <div class="col-md-6 col-12">
                    <div class="d-flex justify-content-md-end align-items-center gap-3 flex-wrap">
                        <div class="flex-grow-1 text-md-end text-start">
                            <h6 class="fw-semibold mb-1 text-dark">{{ companyDetail?.name || 'Company' }}</h6>
                            @if(companyDetail?.email || companyDetail?.phone) {
                            <div class="d-flex flex-wrap justify-content-md-end gap-2">
                                @if(companyDetail?.email) {
                                <a class="text-muted small text-decoration-none d-flex align-items-center">
                                    <i class="bi bi-envelope me-1 fs-7"></i>
                                    <span class="text-truncate" style="max-width: 140px;">{{ companyDetail.email
                                        }}</span>
                                </a>
                                }
                                @if(companyDetail?.phone) {
                                <a class="text-muted small text-decoration-none d-flex align-items-center">
                                    <i class="bi bi-telephone me-1 fs-7"></i>
                                    {{ companyDetail.phone }}
                                </a>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <hr class="m-0 p-o">
            <hr class="m-0 p-o">
            <div class="row">
                <div class="col-lg-3  ">
                    <div class="">
                        <ng-select class="" [items]="allCategoriesMini" bindLabel="name" bindValue="_id"
                            placeholder="Select Category" class="text-dark" [(ngModel)]="sampleSearch.category"
                            name="category" (change)="sampleFilter($event)" [appendTo]="'body'"
                            dropdownPosition="bottom">
                        </ng-select>
                    </div>
                </div>
                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By Name</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>
                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By Barcode</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.barCode" name="barCode"
                            (input)="onBarCodeInputChange($event)">
                    </mat-form-field>
                </div>
                <div class="col-lg-3">
                    <mat-form-field class="w-100" (click)="picker.open()">
                        <mat-label>Search By Sample Added</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start" [(ngModel)]="sampleSearch.startdate" readonly />
                            <input matEndDate placeholder="End" [(ngModel)]="sampleSearch.enddate"
                                (dateChange)="sampleFilter($event)" readonly />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        @if (sampleSearch.startdate || sampleSearch.enddate) {
                        <mat-icon matSuffix (click)="clearDateRange()" class="clear-icon"
                            style="cursor: pointer;">close</mat-icon>
                        }
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
            <div class="table-responsive">
                <table mat-table [dataSource]="samplesDataSource" multiTemplateDataRows
                    class="mat-table table-bordered compact-table ">
                    <ng-container matColumnDef="issuedGroup">
                        <th mat-header-cell *matHeaderCellDef colspan="4" class="text-center py-1">Issued</th>
                    </ng-container>

                    <ng-container matColumnDef="limitGroup">
                        <th mat-header-cell *matHeaderCellDef colspan="3" class="text-center py-1">Limit</th>
                    </ng-container>
                    <ng-container matColumnDef="holdGroup">
                        <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center py-1">Hold</th>
                    </ng-container>
                    <!-- Row Index
                    <ng-container matColumnDef="srno">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">#</th>
                        <td mat-cell *matCellDef="let row; let index = index" class="py-1">
                            {{ index + 1 + ((paginator?.pageIndex || 0) * (paginator?.pageSize || 0)) }}
                        </td>
                    </ng-container> -->

                    <!-- Sample Name -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1 ">Name</th>
                        <td mat-cell *matCellDef="let element" class="text-nowrap py-1">
                            <div class="fw-medium">{{ element.name }}</div>
                            <small class="text-muted fs-7">{{ element.categoryId.name }}</small>
                        </td>
                    </ng-container>
                    <!-- Barcode -->
                    <ng-container matColumnDef="sampleCode">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Bar Code</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.sampleCode }}</td>
                    </ng-container>
                    <!-- Totals -->
                    <ng-container matColumnDef="totalItems">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Total</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.totalItems }}</td>
                    </ng-container>
                    <ng-container matColumnDef="leftItems">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Stock</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.leftItems }}</td>
                    </ng-container>
                    <!-- Issued Columns -->
                    <ng-container matColumnDef="issuedWHL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">WHL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.issuedToWHL }}</td>
                    </ng-container>
                    <ng-container matColumnDef="issuedRTL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">RTL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.issuedToRTL }}</td>
                    </ng-container>
                    <ng-container matColumnDef="issuedCus">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Cus.</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.issuedToCustomer }}</td>
                    </ng-container>
                    <ng-container matColumnDef="issuedTotal">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Total</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            {{ element.issuedToWHL + element.issuedToRTL + element.issuedToCustomer }}
                        </td>
                    </ng-container>
                    <!-- Limit Columns -->
                    <ng-container matColumnDef="limitWHL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">WHL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.maxIssueQuantityWholesaler }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="limitRTL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">RTL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.maxIssueQuantityRetailer }}</td>
                    </ng-container>
                    <ng-container matColumnDef="limitCus">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Cus.</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.maxIssueQuantityCustomer }}</td>
                    </ng-container>
                    <!-- Hold Columns -->
                    <ng-container matColumnDef="holdWHL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">WHL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.holdToWHL }}</td>
                    </ng-container>
                    <ng-container matColumnDef="holdRTL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">RTL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{ element.holdToRTL }}</td>
                    </ng-container>

                    <!-- Issue Date -->
                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Created AT</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            <div>{{ element.createdAt | date: 'dd/MM/yyyy' }}</div>
                            <small>{{ element.createdAt | date: 'hh:mm a' }}</small>
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Preview</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            <mat-icon (click)="openSDetailModal(element._id)" class="c_btn" fontIcon="visibility"
                                aria-hidden="false" aria-label="Detail icon"></mat-icon>
                        </td>
                    </ng-container>

                    <!-- Header Rows -->
                    <tr mat-header-row *matHeaderRowDef="headerRowDef1; sticky: true" class="t_head"></tr>
                    <tr mat-header-row *matHeaderRowDef="headerRowDef2; sticky: true" class="t_head"></tr>

                    <!-- Data Row -->
                    <tr mat-row *matRowDef="let row; columns: sampleDisplayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="sampleDisplayedColumns.length">
                            No data available
                        </td>
                    </tr>


                </table>
            </div>

            <!-- Paginator -->
            <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllSamples($event)">
            </mat-paginator>


        </app-card>
    </div>
</div>



<!-- Get Sample Detail -->

<div class="modal fade" id="sampleDetailModal" tabindex="-1" aria-labelledby="sampleDetailModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-1 rounded-3 overflow-hidden">
            <div class="modal-header border-1 p-2">
                <button type="button" class="btn-close" (click)="hideSDetailModal()"></button>
            </div>

            <div class="container-fluid p-0">
                <div class="card border-1 rounded-0">
                    <!-- Header Section -->
                    <div class="card-header bg-gradient-primary text-white p-3">
                        <div class="d-flex flex-wrap justify-content-between align-items-start">
                            <div>
                                <h5 class="fw-semibold text-dark mb-1">{{sampleData?.name}}</h5>
                                <small class="text-dark">{{sampleData?.categoryId.name}}</small>
                                <div class="d-flex flex-wrap gap-2 mt-1">
                                    @if (sampleData?.sampleCode) {
                                    <span class="fw-bold text-dark">Barcode: {{sampleData.sampleCode}}</span>
                                    }
                                </div>
                            </div>
                            <div class="text-end text-dark small">
                                @if (sampleData?.companyId?.name) {
                                <div><strong>Added by:</strong> {{sampleData.companyId.name}}</div>
                                }
                                @if (sampleData?.createdAt) {
                                <div><strong>Created:</strong> {{sampleData.createdAt | date}}</div>
                                }
                            </div>
                        </div>
                    </div>

                    <!-- Body Section -->
                    <div class="card-body p-3">
                        <div class="row g-3">
                            <!-- Images Gallery -->
                            <div class="col-md-4">
                                @if (sampleData?.sampleImages?.length) {
                                <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
                                    <div class="carousel-inner rounded">
                                        @for (image of sampleData.sampleImages; track image; let i = $index) {
                                        <div class="carousel-item" [class.active]="i === 0">
                                            <img [src]="getImg(image)" class="d-block w-100 img-fluid"
                                                style="height: 300px; object-fit: cover;" alt="Sample Image">
                                        </div>
                                        }
                                    </div>
                                    <button class="carousel-control-prev" type="button"
                                        data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon bg-dark rounded-circle p-2"></span>
                                        <span class="visually-hidden">Previous</span>
                                    </button>
                                    <button class="carousel-control-next" type="button"
                                        data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                                        <span class="carousel-control-next-icon bg-dark rounded-circle p-2"></span>
                                        <span class="visually-hidden">Next</span>
                                    </button>
                                </div>
                                } @else {
                                <div class="bg-light rounded d-flex align-items-center justify-content-center"
                                    style="height: 300px;">
                                    <p class="text-muted mb-0">No images available</p>
                                </div>
                                }

                                @if (sampleData?.videoLink) {
                                <div class="mt-3">
                                    <h6 class="fw-bold mb-2">Product Video</h6>
                                    <div class="ratio ratio-16x9">
                                        <iframe [src]="sampleData.videoLink | safeUrl" frameborder="0"
                                            allowfullscreen></iframe>
                                    </div>
                                </div>
                                }
                            </div>

                            <!-- Details Section -->
                            <div class="col-md-7">
                                <!-- Inventory Status -->
                                <div class="row text-center mb-3">
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Total</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.totalItems || 0}}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Available</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.leftItems || 0}}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Assigned</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.assignedItems || 0}}</span>
                                    </div>
                                </div>

                                <!-- Product Details -->
                                <div class="mb-3">
                                    <h6 class="fw-bold border-bottom pb-1">Product Details</h6>

                                    @if (sampleData?.description) {
                                    <div><small class="fw-bold">Description:</small>
                                        <div [innerHTML]="sampleData.description"></div>
                                    </div>
                                    }
                                    @if (sampleData?.aboutSample) {
                                    <div><small class="fw-bold">About Sample:</small>
                                        <div [innerHTML]="sampleData.aboutSample"></div>
                                    </div>
                                    }
                                    @if (sampleData?.ingredients) {
                                    <div><small class="fw-bold">Ingredients:</small>
                                        <div [innerHTML]="sampleData.ingredients"></div>
                                    </div>
                                    }
                                    @if (sampleData?.usageInstructions) {
                                    <div><small class="fw-bold">Usage:</small>
                                        <div [innerHTML]="sampleData.usageInstructions"></div>
                                    </div>
                                    }
                                </div>

                                <!-- Issue Limits -->
                                <div>
                                    <h6 class="fw-bold border-bottom pb-1">Issue Limits</h6>
                                    <div class="row text-center">
                                        <div class="col-4">
                                            <small class="text-muted d-block">Customer</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityCustomer ||
                                                0}}</span>
                                        </div>
                                        <div class="col-4">
                                            <small class="text-muted d-block">Retailer</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityRetailer ||
                                                0}}</span>
                                        </div>
                                        <div class="col-4">
                                            <small class="text-muted d-block">Wholesaler</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityWholesaler ||
                                                0}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="card-footer bg-light d-flex justify-content-between align-items-center p-2">
                        <small class="text-muted">Last updated: {{sampleData?.updatedAt | date}}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>